// Process block math
// $$
// L = \frac{1}{2} \rho v^2 S C_L
// $$

import type StateBlock from '../state-block'

export default function math_block(
  state: StateBlock,
  startLine: number,
  endLine: number,
  silent: boolean,
): boolean {
  let pos = state.bMarks[startLine] + state.tShift[startLine]
  let max = state.eMarks[startLine]

  // Check for opening $$
  if (pos + 2 > max) return false

  const marker = state.src.slice(pos, pos + 2)
  if (marker !== '$$') return false

  pos += 2

  // The opening $$ must be on its own line (or only have whitespace after it)
  const firstLine = state.src.slice(pos, max).trim()
  if (firstLine.length > 0) return false

  if (silent) return true

  let nextLine = startLine
  let haveEndMarker = false

  // Search for closing $$
  while (nextLine < endLine) {
    nextLine++
    if (nextLine >= endLine) break

    pos = state.bMarks[nextLine] + state.tShift[nextLine]
    max = state.eMarks[nextLine]

    if (pos < max && state.sCount[nextLine] < state.blkIndent) {
      // non-empty line with negative indent should stop the list:
      break
    }

    // Check for closing $$
    const line = state.src.slice(pos, max).trim()
    if (line === '$$') {
      haveEndMarker = true
      break
    }
  }

  const oldParent = state.parentType
  const oldLineMax = state.lineMax
  state.parentType = 'container'

  // Extract content between opening and closing $$
  const content = state.getLines(startLine + 1, nextLine, 0, false).trim()

  const token = state.push('math_block', 'div', 0)
  token.content = content
  token.markup = '$$'
  token.map = [startLine, nextLine + (haveEndMarker ? 1 : 0)]
  token.meta = { type: 'math' }

  state.parentType = oldParent
  state.lineMax = oldLineMax
  state.line = nextLine + (haveEndMarker ? 1 : 0)

  return true
}
